import {NodeViewWrapper} from "@tiptap/react";

export const CheckboxView = ({editor, node, updateAttributes}) => {
  const isEditable = editor.isEditable;

  return (
    <NodeViewWrapper as="span">
      <input
        type="checkbox"
        checked={node.attrs.checked}
        disabled={!isEditable}
        onChange={() => updateAttributes({checked: !node.attrs.checked})}
      />
    </NodeViewWrapper>
  );
};
